<template>
    <div>
        <button v-if="params.data.estado===0 && $can('avance-eliminar')" type="button" class="btn btn-danger btn-sm" v-on:click="onClick">Borrar</button>
    </div>
</template>

<script>
    export default {
        name: "delete-button",
        methods:{
            onClick(){
                this.params.context.componentParent.borrar(this.params.data);
            }
        }
    }
</script>

<style scoped>

</style>